import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MetadataService } from '../../shared/services/metadata.service';
import { TitleService } from '../../shared/services/title.service';
import { ResponsibleContactDetailsComponent } from '../imprint/responsible-contact-details/responsible-contact-details.component';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.css'],
  standalone: true,
  imports: [CommonModule, ResponsibleContactDetailsComponent],
})
export class PrivacyPolicyComponent implements OnInit {
  constructor(
    private metadataService: MetadataService,
    private titleService: TitleService,
  ) {}

  ngOnInit(): void {
    this.titleService.setTitle(`Datenschutzerklärung`);
    this.metadataService.updateTags(
      `Datenschutzerklärung`,
      `Hier können Sie meine Datenschutzerklärung lesen.`,
      `Datenschutz Datenschutzerklärung privacy policy`,
    );
  }
}
